import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * A Switch allows a user to select a value from a small set of options, often binary.
 */
const Switch = (props) => {
  const { className, label, id, ...otherProps } = props;
  const classNames = classnames('form-switch', className);

  return (
    <label htmlFor={id} className={classNames}>
      <input id={id} {...otherProps} type="checkbox" />
      <i className="form-icon" /> {label}
    </label>
  );
};

Switch.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Optional Label to display along side the Switch. */
  label: PropTypes.string,
  /** Input id */
  id: PropTypes.string,
};

Switch.defaultProps = {
  className: '',
  label: '',
  id: '',
};

export { Switch };
